__turbopack_context__.v({
  "className": "playfair_display_2059e283-module__x24Qpq__className",
});
